module.exports = __webpack_public_path__ + "img/badge-top-work-places.c760fc6f.png";